export const getVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url?.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const toastConfig = {
  position: "top-center",
  autoClose: 3000, // Close after 3 seconds
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const typeOfDevice = () => {
  return window.innerWidth < 760
    ? "mobile"
    : window.innerWidth < 1023
      ? "tab"
      : "laptop";
};

// gtag.js
export const GA_MEASUREMENT_ID = "G-XDHKJ20XCW"; // replace with your GA4 Measurement ID

// Generic function to send events to GA4
export const gtag = (...args) => {
  if (window.gtag) {
    window.gtag(...args);
  }
};

export const enumAndLabelAdapter = (interestName) => {
  return interestName === "APPRENTICESHIP"
    ? "Apprenticeships"
    : interestName === "VACANCY"
      ? "Vacancies"
      : interestName === "PRODUCT"
        ? "Products"
        : interestName === "CONTRACTS"
          ? "Contracts"
          : interestName === "SERVICE"
            ? "Services"
            : interestName === "WORK_EXPERIENCE"
              ? "Experiences of work"
              : interestName === "COURSES"
                ? "Our Courses"
                : ""
}

export const enumToEnumAdaptor = (interestName) => {
  if(interestName === 'PRODUCT') return "PRODUCTS"
  if(interestName === 'SERVICE') return 'SERVICES'
  return interestName
}
